// extracted by mini-css-extract-plugin
export default {"container":"style_container__27Mqd","header":"style_header__4HCKf","subtitle":"style_subtitle__459lH","tabContainer":"style_tabContainer__U6Rjh"};